"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { SecurityCheckIcon } from "@hugeicons-pro/core-solid-rounded";
import type { FC } from "react";

type Props = { color?: string; size?: number };

const ShieldIcon: FC<Props> = ({ color = "currentColor", size = 32 }) => (
  <HugeiconsIcon icon={SecurityCheckIcon} size={size} color={color} />
);

export default ShieldIcon;
